import React, { Component }    from 'react';
import { connect }             from 'react-redux'
import { fetchAuthIfNeeded }   from './../actions/AuthAction';
import { initGeo }             from './../actions/GeoLocationAction';
import { fetchDataIfNeeded }   from './../actions/DataAction';
import { registerGoogle }      from './../actions/AppHeaderAction';
import App                     from './../pages/App';
import LoadingSvg              from '../components/LoadingSvg';
import MuiThemeProvider        from 'material-ui/styles/MuiThemeProvider';

class AppContainer extends Component
{
    componentWillMount = () => {
        if (false === this.props.auth.fetched && false === this.props.auth.fetching)
        {
            this.props.authInstance();
        }
    };

    render = () => {
        if (this.props.auth.fetched)
        {
            return (<App { ...this.props } />);
        }
        else
        {
            return (
                <MuiThemeProvider>
                    <div style={ { height: '100vh' } }>
                        <LoadingSvg />
                    </div>
                </MuiThemeProvider>
            );
        }
    }
}

const mapStateToProps = (state) => {
    return {
        auth  : state.auth,
        user  : state.user,
        theme : state.assets.items.theme,
        logo  : state.assets.items.logo,
        geo   : state.geo,
        filter: state.filter.selected
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        authInstance: () => {
            dispatch(fetchAuthIfNeeded());
        },
        registerGoogle: () => {
            dispatch(registerGoogle);
        },
        fetchData: () => {
          dispatch(fetchDataIfNeeded());
        },
        initGeo: () => {
            dispatch(initGeo());
        }
    };
};

AppContainer = connect(mapStateToProps, mapDispatchToProps)(AppContainer);

export default AppContainer;


// WEBPACK FOOTER //
// ./src/containers/AppContainer.js